import { Loader2 } from "lucide-react"
import { ButtonProps } from "../../../../types"
import { cn } from "../../../utils"

const Button = ({
  children,
  className = "",
  type = "button",
  disabled = false,
  paddingOff = false,
  onClick,
  onKeyDown,
  href,
  target = "_blank",
  refProp,
  text = "sm",
  size = "base",
  isLoading = false,
  title,
  tabIndex = -1
}: ButtonProps) => {
  const paddingClassName = {
    sm: "py-1 px-2",
    base: "py-3 px-4",
    md: "py-4 px-6",
    lg: "py-6 px-8"
  }

  const textClassName = {
    sm: "text-sm",
    base: "text-base",
    md: "text-md",
    lg: "text-lg"
  }

  const cls = cn(
    disabled ? "text-gray-400 pointer-events-none cursor-not-allowed" : "",
    "transition-colors relative inline-flex justify-center items-center border font-medium rounded-md focus:outline-none",
    textClassName[text],
    paddingOff ? "p-0" : paddingClassName[size],
    isLoading ? "pointer-events-none cursor-pointer" : "",
    className
  )

  return href ? (
    <a
      href={href}
      className={cls}
      target={target}
      title={title}
      onKeyDown={onKeyDown}
      tabIndex={tabIndex}
    >
      {isLoading && <Loader2 className="animate-spin h-5 w-5 mr-2" />}
      {children}
    </a>
  ) : (
    <button
      title={title}
      tabIndex={tabIndex}
      ref={refProp}
      disabled={disabled}
      type={type}
      className={cls}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      {isLoading && <Loader2 className="animate-spin h-5 w-5 mr-2" />}
      {children}
    </button>
  )
}

export default Button
